module.exports = __webpack_public_path__ + "media/images/Groupe 163-bcc3f6763a46c7022f415fbb868e772e.svg";